import { ColDef } from "ag-grid-community";

export const columnDef = (): ColDef[] => [
    {
        headerName: "Name",
        field: "Name",
        sortable: true,
        filter: true,
        resizable: true,
        flex: 1,
    },
    {
        headerName: "Light Color",
        field: "LightHex",
        sortable: true,
        resizable: true,
        width: 120,
    },
    {
        headerName: "Dark Color",
        field: "DarkHex",
        sortable: true,
        resizable: true,
        width: 120,
    },
];
